(() => {
  if (customElements.get('trailbrew-tutorial')) return;

  class TrailBrewTutorial extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('[data-trailbrew-tutorial-dialog]');
      this.video = this.querySelector('video');
      this.errorMessage = this.querySelector('[data-tutorial-error]');
      if (!this.dialog || !this.video) return;
      this.initialized = true;

      this.dialog.addEventListener('close', () => this.finishClose());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (
          event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom
        ) this.dialog.close();
      });
      this.video.addEventListener('error', () => {
        if (this.dialog.open) this.errorMessage.hidden = false;
      });
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.finishClose();
    }

    open(trigger) {
      if (!this.initialized || typeof this.dialog.showModal !== 'function') return false;
      if (this.dialog.open) return true;

      try {
        this.dialog.showModal();
      } catch (_) {
        // Preserve the ordinary MP4 link if a browser cannot open the dialog.
        return false;
      }

      this.opener = trigger;
      this.lockScroll();
      this.errorMessage.hidden = true;
      // There is deliberately no video URL in a src attribute before interaction.
      this.video.src = this.video.dataset.tutorialSrc;
      this.video.play().catch(() => {
        // Native controls remain available if automatic playback is restricted.
      });
      return true;
    }

    lockScroll() {
      const body = document.body;
      const properties = ['position', 'top', 'left', 'right', 'width', 'overflow', 'paddingRight'];
      this.scrollPosition = { x: window.scrollX, y: window.scrollY };
      this.bodyStyles = Object.fromEntries(properties.map((property) => [property, body.style[property]]));
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      const paddingRight = parseFloat(getComputedStyle(body).paddingRight) || 0;
      body.style.position = 'fixed';
      body.style.top = `-${this.scrollPosition.y}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) body.style.paddingRight = `${paddingRight + scrollbarWidth}px`;
    }

    finishClose() {
      if (!this.bodyStyles) return;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      Object.assign(document.body.style, this.bodyStyles);
      this.bodyStyles = null;
      const root = document.documentElement;
      const scrollBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
      root.style.scrollBehavior = scrollBehavior;
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      this.opener = null;
    }
  }

  customElements.define('trailbrew-tutorial', TrailBrewTutorial);

  // Delegation survives Shopify theme-editor section reloads and product updates.
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest?.('[data-trailbrew-tutorial-trigger]');
    if (!trigger) return;
    const component = trigger.closest('trailbrew-tutorial') || document.querySelector('trailbrew-tutorial');
    if (component?.open(trigger)) event.preventDefault();
  });
})();
